import React from "react";

// Amden Control brand mark (the "C" logo). Served from the public folder.
export const AMDEN_LOGO = "/logo192.png";
export const SEQ_LOGO = AMDEN_LOGO; // kept for backwards-compatible imports

export function SeqMark({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="seq-mark">
      <img src={AMDEN_LOGO} alt="Amden Control" className="h-8 w-8 rounded-full shrink-0" />
    </div>
  );
}

export function SeqLogo({ className = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="seq-logo">
      <img src={AMDEN_LOGO} alt="Amden Control" className="h-9 w-9 rounded-full shrink-0 ring-1 ring-white/10" />
      {showText && (
        <div className="leading-tight">
          <div className="text-white font-display font-semibold text-[15px]">Amden Control</div>
          <div className="text-slate-300/70 text-[10px] uppercase tracking-widest">Platform</div>
        </div>
      )}
    </div>
  );
}
